module.exports = __webpack_public_path__ + "static/img/why-2.d47ae31d.jpg";